import { Dialog } from '@mui/material';
import Button from 'components/Button';
import PropTypes from 'prop-types';

import './style.scss';


const BasicDialog = (props) => {
  return (
    <Dialog
      classes={{
        root: 'dialogRoot',
        paper: 'dialogPaper',
        container: 'dialogContainer'
      }}
      style={{ position: 'absolute' }}
      onClose={props.handleClose}
      open={true}
    >
      <div className="dialog-title">{props.title}</div>
      <div className="dialog-description">{props.description}</div>
      <div className="dialog-actions">
        <Button 
          handleClick={() => props.handleSubmit()} 
          txt={'אישור'}
          disabled={props.isSubmitDisable || props.isActionsDisabled}
        ></Button>
        <Button 
          handleClick={props.handleClose} 
          txt={'ביטול'}
          disabled={props.isCancelDisable || props.isActionsDisabled}
        ></Button>
      </div>
    </Dialog>
  );
};

export default BasicDialog;

BasicDialog.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  isActionsDisabled: PropTypes.bool,
  isSubmitDisable: PropTypes.bool,
  isCancelDisable: PropTypes.bool
};
